<script lang="ts" setup>
/**
 * コミュニティトークのタイトル。
 */

import { defineProps } from "vue";

interface Props {
	/**
	 * 見出し文言。
	 */
	title: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps<Props>();
</script>

<template>
	<header class="revico-community-talk-title">
		<h1 class="revico-community-talk-title--text"><font-awesome-icon icon="fa-regular fa-message" />{{ title }}</h1>
	</header>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	&-title {
		margin-bottom: 20px;
		&--text {
			font-size: 1.2em;
			font-weight: bold;
		}

		.fa-message {
			margin-right: 4px;
			font-size: 0.9em;
		}
	}
}
</style>
